
import styled from 'styled-components'
import {colors} from 'buoy-theme'

const MoreOptions = styled.div`
  position: fixed;
  bottom: 0;
  height: 82px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  left: 0;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  z-index: 99;
  padding-bottom: 8px;
  transition: opacity 0.5s ease-in;
  pointer-events: none;
  
  ${props => props.show ? `opacity: 1;` : 
    `opacity: 0.01; 
     pointer-events: none;`
  }

  a {
    pointer-events:  ${props => props.show ? 'all' : 'none'};
    text-decoration: none;
    color: ${colors.primaryDark}
  }
`

export {MoreOptions as default}


// WEBPACK FOOTER //
// ./assets/interview/components/MoreOptions.js